<template>
  <div>
    <Form ref="quoteSingleProductForm" :model="formData" label-position="top" :key="quote.id" :disabled="disabled">
      <Row :gutter="32" class="align-items-center">
        <Col span="12">
          <FormItem :label="$t('quote.info.product')" prop="product_id" :rules="{ required: true, message: 'Product is required.'}">
            <ProductSearchWidget :product="product" @on-changed="handleProductChanged" :disabled="hasCostEstimated || disabled"></ProductSearchWidget>
            <div v-if="product" class="text-align-right" style="font-size: 12px; color: rgb(128, 134, 149);">
              <router-link :to="{ name: 'menu.product.edit', params: { productId: product.id } }" target="_blank">{{ $t('quote.info.product_field_help_desc') }}</router-link>
            </div>
          </FormItem>
        </Col>
        <Col span="6">
          <FormItem :label="$t('quote.info.quantity')" prop="quantity" :rules="{ message: 'Quantity is required.', type: 'number' }" required>
            <InputNumber v-model="formData.quantity" :disabled="disabled"></InputNumber>
          </FormItem>
        </Col>
        <Col span="6">
          <FormItem :label="$t('quote.info.expected_delivery_date')">
            <DatePicker :value="formData.expected_delivery_date" type="date" @on-change="handleLeadTimeChange"></DatePicker>
          </FormItem>
        </Col>
      </Row>
    </Form>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import ProductSearchWidget from '@/view/product/widgets/product-search-widget.vue'

export default {
  name: 'QuoteTypeSingleProductForm',
  props: {
    quote: {
      type: Object
    },
    singleProduct: {
      type: Object,
      default: () => {
        return {}
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    hasCostEstimated: {
      type: Boolean,
      default: false
    }
  },
  components: {
    ProductSearchWidget
  },
  data() {
    return {
      formData: { quantity: 1 },
      product: null
    }
  },
  mounted () {
    let data = this.singleProduct
    if (this.$route.query.product_id) {
      data.product_id = _.toNumber(this.$route.query.product_id)
    }

    this.setData(data)
  },
  watch: {
    formData: {
      handler: function () {
        this.$emit('update:singleProduct', this.formData)
      },
      deep: true
    }
  },
  methods: {
    ...mapActions([
      'getProduct'
    ]),
    setData(data) {
      if (!_.isEmpty(data)) {
        this.$nextTick(() => {
          this.loadProduct(data.product_id)
          this.formData = data
          this.formData.quantity = data.quantity
          this.formData.quote_id = this.quote ? this.quote.quote_id : null
        })
      }
    },
    loadProduct(productId) {
      if (productId) {
        this.getProduct(productId).then(product => {
          this.product = product
          this.$emit('input', this.product.id)
        })
      }
    },
    handleLeadTimeChange(e) {
      this.formData.expected_delivery_date = e
    },
    handleProductChanged(product) {
      this.product = product
      this.$set(this.formData, 'product_id', product.id)
    },
    handleValidateForm() {
      let formValid = false
      this.$refs['quoteSingleProductForm'].validate(valid => {
        formValid = valid
      })
      return formValid
    }
  }
}
</script>

<style lang="less" scoped>

</style>
